<form id="subpoena-plaintiffCounseal-form-pg" [formGroup]="formGroup">
    <!-- Code Implementation for Contact Information class="flex flex-col gap-4" -->

        <!-- Case Information Component -->
        <app-case-information 
        [formGroup]="formGroup" 
        [states]="states"
        [idPrefix]="'subpoena'"
        [headerText]="'Court details'">
    </app-case-information>

        <!-- <div class="mb-3"> -->
        <div *ngFor="let option of chooseCounsellOptions" class="d-inline-flex mb-3 displayNone">
            <p-radioButton 
                [name]="'chooseCounsell'" 
                [value]="option.value" 
                formControlName="chooseCounsell" 
                [inputId]="'chooseCounsell-' + option.value"
                (onClick)="toggleCounsellControls(option.value)">
            </p-radioButton>
            <label [for]="'chooseCounsell-' + option.value" class="ms-2 me-4">
            {{ option.label }}
            </label>
        </div>
        <!-- </div> -->
    <p-panel header="Plaintiff Details" styleClass="panel-skew-heading-with-border"> 
        <!-- <p-panel header="Plaintiff Details Section" 
            styleClass="border-0 panel-dotted-heading"> -->
                <div formArrayName="plaintiffCounseals">
                    <div *ngFor="let plaintiffCounseal of plaintiffCounseals.controls; let i = index" [formGroupName]="i"
                        [ngClass]="{'mt-5': i > 0}">
                        <div class="row mb-3">
                            <div class="col-sm-12">
                                <div class="border-bottom-dotted d-flex justify-content-between align-items-center">
                                    <h2 class="contactListNo">
                                        <span *ngIf="i<9">Plaintiff Counsel {{ '0'+ (i + 1) }}</span>
                                        <span *ngIf="i>=9">Plaintiff Counsel {{ i + 1 }}</span>
                                    </h2>
                                    <p-button icon="pi pi-trash" styleClass="p-0 mb-1" [link]="true" [text]="true"
                                        aria-label="Delete" label="Delete"
                                        *ngIf="plaintiffCounseals && plaintiffCounseals.length > 1"
                                        (onClick)="removePlaintiffCounseal(i)" [disabled]="editOrder && !plaintiffCounseal?.value?.isNew"></p-button>
                                </div>
                                <!--  <hr /> -->
                            </div>
                        </div>
                    
                   
                <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-3 mb-3" *ngIf="(formGroup.get('chooseCounsell')?.value === false && i>0) || formGroup.get('chooseCounsell')?.value === true">
                            <label for="subpoena-plaintiffCounseal-plaintiff-counsel-full-name-{{i}}"
                                class="form-label d-block required-asterisk">Plaintiff Counsel Full Name</label>
                            <input pInputText type="text"
                                id="subpoena-plaintiffCounseal-plaintiff-counsel-full-name-{{i}}" class="w-100"
                                placeholder="Enter plaintiff counsel full name"
                                formControlName="plantiffCounselAttorneyName"
                                [ngClass]="{'ng-invalid ng-dirty' : isError('plantiffCounselAttorneyName', plaintiffCounseal)}" />
                            <small id="order-info-ref-num-error"
                                *ngIf="isError('plantiffCounselAttorneyName', plaintiffCounseal)" class="error-label">This
                                field is mandatory</small>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3 mb-3" *ngIf="(formGroup.get('chooseCounsell')?.value === false && i>0) || formGroup.get('chooseCounsell')?.value === true">
                            <label for="subpoena-plaintiffCounseal-plaintiff-counsel-bar-number-{{i}}"
                                class="form-label d-block">Bar Number</label>
                            <input pInputText type="text" id="subpoena-plaintiffCounseal-plaintiff-counsel-bar-number-{{i}}"
                                class="w-100" placeholder="Enter bar number"
                                formControlName="plantiffCounselBarNumer"
                                [ngClass]="{'ng-invalid ng-dirty' : isError('plantiffCounselBarNumer', plaintiffCounseal)}" />
                            
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                            <label for="subpoena-plaintiffcounseal-plaintiff-counsel-law-firm-{{i}}"
                                class="form-label d-block required-asterisk">Law Firm</label>
                            <input pInputText type="text" id="subpoena-plaintiffcounseal-plaintiff-counsel-law-firm-{{i}}"
                                class="w-100" placeholder="Enter law firm"
                                formControlName="plantiffCounselFirmName"
                                [ngClass]="{'ng-invalid ng-dirty' : isError('plantiffCounselFirmName', plaintiffCounseal)}" />
                            <small id="order-info-ref-num-error"
                                *ngIf="isError('plantiffCounselFirmName', plaintiffCounseal)" class="error-label">This field
                                is mandatory</small>
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                            <label for="subpoena-plaintiffCounseal-representing-{{i}}"
                                    class="form-label d-block required-asterisk">
                                    Representing - Plaintiff
                            </label>

                            <p-multiselect 
                                [options]="plaintiffSubjectNames" 
                                [showToggleAll]="false" 
                                [filter]="false" 
                                display="chip" 
                                inputId="subpoena-plaintiffCounseal-representing-{{i}}" 
                                id="subpoena-plaintiffCounseal-representing-{{i}}"
                                styleClass="w-100" 
                                formControlName="plaintiffs" 
                                optionLabel="name"
                                placeholder="Select representing" 
                                [ngClass]="{'ng-invalid ng-dirty' : isError('plaintiffs', plaintiffCounseal)}">

                                <!-- Custom footer -->
                                <ng-template pTemplate="footer">
                                <div class="p-2 text-primary cursor-pointer p-multiSelectFooter" (click)="openAddPartyModal('plaintiff',i)">
                                    Don’t see your results? Click here to add more.
                                </div>
                                </ng-template>

                            </p-multiselect>

                            <small id="order-info-ref-num-error" 
                                *ngIf="isError('plaintiffs', plaintiffCounseal)"
                                class="error-label">
                                This field is mandatory
                            </small>
                        </div>

                    <!-- </div>
                    <div class="row mb-0 mb-lg-3"> -->
                        <div class="col-sm-12 col-md-6 col-lg-3 mb-3" *ngIf="(formGroup.get('chooseCounsell')?.value === false && i>0) || formGroup.get('chooseCounsell')?.value === true">
                            <label for="subpoena-plaintiffCounseal-street-address-{{i}}" class="form-label d-block">Street
                                Address</label>
                            <input pInputText type="text" id="street-address-{{i}}" class="w-100"
                                placeholder="Enter street address" formControlName="streetAddress" />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3 mb-3" *ngIf="(formGroup.get('chooseCounsell')?.value === false && i>0) || formGroup.get('chooseCounsell')?.value === true">
                            <label for="subpoena-plaintiffCounseal-city-{{i}}" class="form-label d-block">City</label>
                            <input pInputText type="text" id="subpoena-plaintiffCounseal-city-{{i}}" class="w-100"
                                placeholder="Enter city" formControlName="city" />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3 mb-3" *ngIf="(formGroup.get('chooseCounsell')?.value === false && i>0) || formGroup.get('chooseCounsell')?.value === true">
                            <label for="subpoena-plaintiffCounseal-state-{{i}}" class="form-label d-block">State</label>
                            <p-select formControlName="state" id="subpoena-plaintiffCounseal-state-{{i}}" [options]="states"
                                optionLabel="name" placeholder="Select state" styleClass="w-100" />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3 mb-3" *ngIf="(formGroup.get('chooseCounsell')?.value === false && i>0) || formGroup.get('chooseCounsell')?.value === true">
                            <label for="subpoena-plaintiffCounseal-zip-{{i}}" class="form-label d-block">Zip</label>
                            <input pInputText type="text" id="subpoena-plaintiffCounseal-zip-{{i}}" class="w-100"
                                placeholder="Enter zip" formControlName="zip" />
                        </div>
                    <!-- </div>
                    <div class="row mb-0 mb-lg-3"> -->
                        <div class="col-8 col-md-4 col-lg-2 mb-3 pe-1" *ngIf="(formGroup.get('chooseCounsell')?.value === false && i>0) || formGroup.get('chooseCounsell')?.value === true">
                            <label for="subpoena-plaintiffCounseal-phone-{{i}}" class="form-label d-block">Phone</label>
                            <p-inputmask mask="(999) 999-9999" id="subpoena-plaintiffCounseal-phone-{{i}}" class="w-100 phone-inputmask"
                                placeholder="Enter phone" formControlName="phone" autocomplete="new-password"/>
                        </div>
                        <div class="col-4 col-md-2 col-lg-1  mb-3 ps-1" *ngIf="(formGroup.get('chooseCounsell')?.value === false && i>0) || formGroup.get('chooseCounsell')?.value === true">
                            <label for="subpoena-plaintiffCounseal-phone-extn-{{i}}"
                                class="form-label d-block">Extension</label>
                            <input pInputText type="text" id="subpoena-plaintiffCounseal-phone-extn-{{i}}"
                                placeholder="Enter" formControlName="extn" class="w-100" />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3 mb-3" *ngIf="(formGroup.get('chooseCounsell')?.value === false && i>0) || formGroup.get('chooseCounsell')?.value === true">
                            <label for="subpoena-plaintiffCounseal-fax-{{i}}" class="form-label d-block">Fax</label>
                            <input pInputText type="text" id="subpoena-plaintiffCounseal-fax-{{i}}" class="w-100"
                                placeholder="Enter fax" formControlName="fax" />
                        </div>
                        <div class="col-sm-12 col-md-6 col-lg-3 mb-3" *ngIf="(formGroup.get('chooseCounsell')?.value === false && i>0) || formGroup.get('chooseCounsell')?.value === true">
                            <label for="subpoena-plaintiffCounseal-email-{{i}}" class="form-label d-block">Email</label>
                            <input pInputText type="email" id="subpoena-plaintiffCounseal-email-{{i}}" class="w-100"
                                placeholder="Enter email" formControlName="email" />
                            <small *ngIf="plaintiffCounseal?.get('email')?.hasError('email')" class="error-label">Please
                            enter a valid email address.</small>
                        </div>
                </div>
                </div>
                </div>
                <p-button label="Add Plaintiff Counsel" styleClass="px-0" icon="pi pi-plus" (onClick)="addPlaintiffCounseal()"
                    [link]="true" />
        <!-- </p-panel> -->
    </p-panel>
    <!-- <br>
    <span class="versus">vs</span> -->

    <div class="vertical-line">
        <span class="txtCenter">V.</span>
    </div>

    <p-panel header="Defendant Details" styleClass="panel-skew-heading-with-border">
        <p-panel styleClass="border-0 panel-dotted-heading">
            <div formArrayName="defendantCounseals" class="">
                <div *ngFor="let defendant of defendantCounseals.controls; let i = index" [formGroupName]="i"
                    [ngClass]="{'mt-5': i > 0}">
                    <div class="row mb-3">
                        <div class="col-sm-12">
                            <div class="border-bottom-dotted d-flex justify-content-between align-items-center">
                                <h2 class="contactListNo">
                                    <span *ngIf="i<9">Defendant Counsel {{ '0'+ (i + 1) }}</span>
                                    <span *ngIf="i>=9">Defendant Counsel {{ i + 1 }}</span>
                                </h2>
                                <p-button icon="pi pi-trash" styleClass="p-0 mb-1" [link]="true" [text]="true"
                                    aria-label="Delete" label="Delete" *ngIf="defendantCounseals && defendantCounseals.length > 1"
                                    (onClick)="removeDefendant(i)" [disabled]="editOrder && !defendant?.value?.isNew"></p-button>
                            </div>
                            <!--  <hr /> -->
                        </div>
                    </div>
               
                    <div class="row mb-0 mb-lg-3">
                        <div class="col-sm-3 mb-3 mb-sm-0" *ngIf="(formGroup.get('chooseCounsell')?.value === true && i>0) || formGroup.get('chooseCounsell')?.value === false">
                            <label for="subpoena-defendant-counsel-full-name-{{i}}"
                                class="form-label d-block required-asterisk">Defendant Counsel Full Name</label>
                            <input pInputText type="text"
                                id="subpoena-defendant-counsel-full-name-{{i}}" class="w-100"
                                placeholder="Enter plaintiff counsel full name"
                                formControlName="defendantCounselAttorneyName"
                                [ngClass]="{'ng-invalid ng-dirty' : isError('defendantCounselAttorneyName', defendant)}" />
                            <small id="order-info-ref-num-error"
                                *ngIf="isError('defendantCounselAttorneyName', defendant)" class="error-label">This
                                field is mandatory</small>
                        </div>
                        <div class="col-sm-3 mb-3 mb-sm-0" *ngIf="(formGroup.get('chooseCounsell')?.value === true && i>0) || formGroup.get('chooseCounsell')?.value === false">
                            <label for="subpoena-defendant-counsel-bar-number-{{i}}"
                                class="form-label d-block">Bar Number</label>
                            <input pInputText type="text" id="subpoena-defendant-counsel-bar-number-{{i}}"
                                class="w-100" placeholder="Enter bar number"
                                formControlName="defendantCounselBarNumer"
                                [ngClass]="{'ng-invalid ng-dirty' : isError('defendantCounselBarNumer', defendant)}" />
                            
                        </div>
                        <div class="col-sm-3 mb-3 mb-sm-0">
                            <label for="subpoena-defendant-counsel-law-firm-{{i}}"
                                class="form-label d-block required-asterisk">Law Firm</label>
                                
                            <p-select formControlName="defendantCounselFirmName" 
                                *ngIf="!((formGroup.get('chooseCounsell')?.value === true && i>0) || formGroup.get('chooseCounsell')?.value === false)"
                                [options]="accountNames" optionLabel="name" optionValue="value"
                                styleClass="w-100" 
                                [disabled]="true"/>
            
                            <input pInputText type="text" id="subpoena-defendant-counsel-law-firm-{{i}}"
                                *ngIf="(formGroup.get('chooseCounsell')?.value === true && i>0) || formGroup.get('chooseCounsell')?.value === false"
                                class="w-100" placeholder="Enter law firm"
                                formControlName="defendantCounselFirmName"
                                [ngClass]="{'ng-invalid ng-dirty' : isError('defendantCounselFirmName', defendant)}" />
                            <small id="order-info-ref-num-error"
                                *ngIf="isError('defendantCounselFirmName', defendant)" class="error-label">This field
                                is mandatory</small>
                        </div>
                        <div class="col-sm-3 mb-3 mb-sm-0">
                            <label for="subpoena-defendant-representing-{{i}}"
                                class="form-label d-block required-asterisk">
                                Representing - Defendant
                            </label>

                            <p-multiselect 
                                [options]="defendantSubjectNames" 
                                [showToggleAll]="false" 
                                [filter]="false" 
                                display="chip" 
                                inputId="subpoena-defendant-representing-{{i}}" 
                                id="subpoena-defendant-representing-{{i}}"
                                styleClass="w-100" 
                                formControlName="defendants" 
                                optionLabel="name"
                                placeholder="Select representing" 
                                [ngClass]="{'ng-invalid ng-dirty' : isError('defendants', defendant)}">

                                <!-- Custom footer -->
                                <ng-template pTemplate="footer">
                                <div class="p-2 text-primary cursor-pointer p-multiSelectFooter" (click)="openAddPartyModal('defendant',i)">
                                    Don’t see your results? Click here to add more.
                                </div>
                                </ng-template>

                            </p-multiselect>

                            <small id="order-info-ref-num-error" 
                                *ngIf="isError('defendants', defendant)"
                                class="error-label">
                                This field is mandatory
                            </small>
                        </div>

                    </div>
                    <div class="row mb-0 mb-lg-3" *ngIf="(formGroup.get('chooseCounsell')?.value === true && i>0) || formGroup.get('chooseCounsell')?.value === false">
                        <div class="col-sm-3 mb-3 mb-sm-0">
                            <label for="subpoena-defendant-street-address-{{i}}" class="form-label d-block">Street
                                Address</label>
                            <input pInputText type="text" id="street-address-{{i}}" class="w-100"
                                placeholder="Enter street address" formControlName="streetAddress" />
                        </div>
                        <div class="col-sm-3 mb-3 mb-sm-0">
                            <label for="subpoena-defendant-city-{{i}}" class="form-label d-block">City</label>
                            <input pInputText type="text" id="subpoena-defendant-city-{{i}}" class="w-100"
                                placeholder="Enter city" formControlName="city" />
                        </div>
                        <div class="col-sm-3 mb-3 mb-sm-0">
                            <label for="subpoena-defendant-state-{{i}}" class="form-label d-block">State</label>
                            <p-select formControlName="state" id="subpoena-defendant-state-{{i}}" [options]="states"
                                optionLabel="name" placeholder="Select state" styleClass="w-100" />
                        </div>
                        <div class="col-sm-3 mb-3 mb-sm-0">
                            <label for="subpoena-defendant-zip-{{i}}" class="form-label d-block">Zip</label>
                            <input pInputText type="text" id="subpoena-defendant-zip-{{i}}" class="w-100"
                                placeholder="Enter zip" formControlName="zip" />
                        </div>
                    </div>
                    <div class="row mb-0 mb-lg-3" *ngIf="(formGroup.get('chooseCounsell')?.value === true && i>0) || formGroup.get('chooseCounsell')?.value === false">
                        <div class="col-8 col-md-2 col-lg-2 mb-3 mb-sm-0 pe-1">
                            <label for="subpoena-defendant-phone-{{i}}" class="form-label d-block">Phone</label>
                            <p-inputmask mask="(999) 999-9999" id="subpoena-defendant-phone-{{i}}" class="w-100 phone-inputmask"
                                placeholder="Enter phone" formControlName="phone" autocomplete="new-password"/>
                        </div>
                        <div class="col-4 col-md-1 col-lg-1 mb-3 mb-sm-0 ps-1">
                            <label for="subpoena-defendant-phone-extn-{{i}}"
                                class="form-label d-block">Extension</label>
                            <input pInputText type="text" id="subpoena-defendant-phone-extn-{{i}}"
                                placeholder="Enter" formControlName="extn" class="w-100" />
                        </div>
                        <div class="col-sm-3 mb-3 mb-sm-0">
                            <label for="subpoena-defendant-fax-{{i}}" class="form-label d-block">Fax</label>
                            <input pInputText type="text" id="subpoena-defendant-fax-{{i}}" class="w-100"
                                placeholder="Enter fax" formControlName="fax" />
                        </div>
                        <div class="col-sm-3 mb-3 mb-sm-0">
                            <label for="subpoena-defendant-email-{{i}}" class="form-label d-block">Email</label>
                            <input pInputText type="email" id="subpoena-defendant-email-{{i}}" class="w-100"
                                placeholder="Enter email" formControlName="email" />
                            <small *ngIf="defendant?.get('email')?.hasError('email')" class="error-label">Please
                            enter a valid email address.</small>
                        </div>
                    </div>
                
                </div>
            </div>
            <p-button label="Add Defendant Counsel" styleClass="px-0" icon="pi pi-plus" (onClick)="addDefendant()" [link]="true" />
        </p-panel>
    </p-panel>
</form>

<app-modal [header]="'Delete Confirmation'" [(showDialog)]="showDeleteModal" [rejectLabel]="'No'" [acceptLabel]="'Yes'"
    (acceptModalClick)="delete()" (rejectModalClick)="showDeleteModal = false">
    <span>Are you sure want to delete this?</span>
</app-modal>
<app-modal
  [(showDialog)]="showAddPartyModal"
  [header]="'Add Party'"
  [acceptLabel]="'Continue'"
  [rejectLabel]="'Cancel'"
  (acceptModalClick)="saveParty()"
  (rejectModalClick)="onModalCancel()"
>
  <div class="add-party-form">
    <div *ngFor="let name of partyNames; let i = index; trackBy: trackByIndex" class="party-input">
      <label *ngIf="i === 0" for="partyName">Party Name <span class="text-danger">*</span></label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="partyNames[i]"
        placeholder="Enter party name"
        [ngClass]="{ 'is-invalid': showValidationErrors && !partyNames[i]?.trim() }"
      />
      <div class="invalid-feedback" *ngIf="showValidationErrors && !partyNames[i]?.trim()">
        This field is mandatory
      </div>
    </div>

    <a href="#" class="add-more-link" (click)="addMoreInput($event)">+ Add More</a>
  </div>
</app-modal>
